// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__l3Osk","signatureButtonsRight":"ModalSign_signatureButtonsRight__7ewqD"};